import { isEmpty } from 'lodash';

import moment from 'moment';

import {
  transformBooleanToStringQaSpecValue,
  transformStringToBooleanQaSpecValue,
} from 'pages/qa-spec/utils/transformQaBooleanValue';

import { addUtcForIsoString } from 'utils/timezone';

const IGNORE_KEYS = ['contains', 'doesNotContain'];

export const transformQaClaimsToFormValues = (dataQaClaims) => {
  let result = {};

  if (dataQaClaims) {
    for (const [key, value] of Object.entries(dataQaClaims)) {
      result = {
        ...result,
        [key]: IGNORE_KEYS.includes(key)
          ? value
          : transformBooleanToStringQaSpecValue(value),
      };
    }
  }

  return result;
};

export const transformQaClamsToParams = (formValues) => {
  let result = {};

  for (const [key, value] of Object.entries(formValues)) {
    result = {
      ...result,
      [key]: IGNORE_KEYS.includes(key)
        ? value
        : transformStringToBooleanQaSpecValue(value),
    };
  }

  return result;
};

export const generateDefaultQaClaims = (dataClaims, requiredClaims) => {
  const claims = dataClaims?.claims || [];
  
  let newClaims = claims;

  if (isEmpty(claims)) {
    newClaims = requiredClaims.map((claim) => ({
      claimTypeCode: claim.enumDisplayName,
      isAttribute: null,
      willCustomerFacing: null,
      isThirdParty: null,
      additionalInformation: null,
    }));
    return {
      ...dataClaims,
      claims: newClaims,
    };
  }

  return dataClaims;
};

export const generateFormValuesClaims = (claims) => {
  if (isEmpty(claims)) {
    return {};
  }

  return claims.reduce((acc, item) => {
    acc[item.claimTypeCode] = item;
    return acc;
  }, {});
};

export const mapClaimsEnumByValue = (enumArray) => {
  if (!Array.isArray(enumArray) || isEmpty(enumArray)) {
    return {};
  }

  return enumArray.reduce((acc, item) => {
    acc[item.enumDisplayName] = item;
    return acc;
  }, {});
};

export const mapObjectToArrayWithKey = (obj) => {
  if (isEmpty(obj)) {
    return [];
  }

  return Object.keys(obj).map((key) => ({
    claimTypeCode: key,
    ...obj[key],
  }));
};

export const transformDatetimeForFormValues = (value) => {
  if (!value) return null;

  let newValue = value;
  newValue = newValue ? addUtcForIsoString(newValue) : null;
  newValue = newValue ? moment(newValue) : null;
  return newValue;
};